import React, { useState, useEffect } from 'react';

import axios from "axios";

const Caricamento_dati_utente = (props) => {

const [cognome, set_cognome] = useState('');

const [nome, set_nome] = useState('');
const [utente_new, set_utente_new] = useState('');
const [utente_new_caricato, set_in_utente_new_caricato] = useState('');

const [lista_youtube, set_in_lista_youtube] = useState('');
const [lista_youtube_caricata, set_in_lista_youtube_caricata] = useState(false);
const [file_utente_caricata, set_in_file_utente_caricata] = useState(false);
const [todos_in, setTodos_in] = useState([])
      

useEffect(() => {
    console.log('useEffect Call_php_iniziale')
    if (lista_youtube_caricata) {
        setTimeout(function(){
            chiamata_file_php_caricamento_utente (); 
         }, 2000);
        



        set_in_lista_youtube_caricata(false)
    }
    if (file_utente_caricata) {
        controlla_i_dati_caricati_aggiorna_array()
        chiamata_file_php_caricamento_utente_todo()
        set_in_file_utente_caricata(false)
    }
    // Good!
  }, [lista_youtube_caricata, file_utente_caricata]);


const chiamata_file_php_caricamento_utente_todo = () => {
    console.log('YYYYYYYYYYY axios')

    console.log(utente_new)
    
    axios({
        method: "post",
        url: 'https://www.idroslab.com/react_video_jobs/carica_utente_todo.php',
        headers: { "content-type": "application/json" },
        data: utente_new
    }).then(data => {
        console.log('ZZZZZZZ Caricamento TODOS')

        if (data.data !== 'non_trovato') {
            props.setTodos(data.data)
            console.log('ZZZZZZZ Caricamento riuscito')
            console.log(data.data)
        }else{console.log('ZZZZZZZ  CARICAMENTO NO')}
    }
    ).catch(err => {
        console.log('errore in axios')
        console.log(err)
        return null
    })
};


const controlla_i_dati_caricati_aggiorna_array = () => {
    var utente_new_aux = utente_new
    
    const sweeterArray = lista_youtube.map((itemtodo, index) => {

        if (utente_new_aux.video_guardati[index].file ===  utente_new_caricato.video_guardati[index].file) 
           utente_new_aux.video_guardati[index].array_visione = utente_new_caricato.video_guardati[index].array_visione 
    })
    set_utente_new(utente_new_aux)
    props.funzione_set_lista_utenti(utente_new_aux)
     
}

const chiamata_file_php_caricamento_utente = () => {
    console.log('YYYYYYYYYYY axios')
    console.log(lista_youtube)

    var utente_new_aux = { nome: nome, cognome: cognome, creato: false, video_guardati: [], }
    var todos_aux = [] 
    
    const sweeterArray = lista_youtube.map((itemtodo, index) => {
        utente_new_aux.video_guardati.push({video_scelto: itemtodo.file, array_visione: [0,0,0,0,0,0,0,0,0,0]}) 
        todos_aux.push({domanda: []})
    })
    setTodos_in(todos_aux)
    props.setTodos(todos_aux)
    set_utente_new(utente_new_aux)
    props.funzione_set_lista_utenti(utente_new_aux)

    console.log(utente_new_aux)
    axios({
        method: "post",
        url: 'https://www.idroslab.com/react_video_jobs/carica_utente.php',
        headers: { "content-type": "application/json" },
        data: utente_new_aux
    }).then(data => {
        console.log('YYYYYY CARICAMENTO UTENTE')
        console.log(data.data)
        if (data.data !== 'non_trovato') {
            console.log('YYYYYY CARICAMENTO RIUSCITO')

            set_in_utente_new_caricato(data.data)
            
            set_in_file_utente_caricata(true)
            
        } else
        {console.log('YYYYYY CARICAMENTO NO')}
    }
    ).catch(err => {
        console.log('errore in axios Uten')
        console.log(err)
        return null
    })
};





const chiamata_file_php_lista_youtube = () => {
    var formData = {"nome": nome, "cognome": cognome}; 

    axios({
        method: "post",
        url: 'https://www.idroslab.com/react_video_jobs/lista_file_video.php',
        headers: { "content-type": "application/json" },
        data: formData
      }).then(data => {
        console.log('XXXX call_php_start.js chiamata_file_php 11')
        props.funzione_set_lista_file(data.data)
        set_in_lista_youtube(data.data)
        console.log('XXXXX CARICAMENTO LISTA YOUTUBE')
      
        if (data.data.length > 0) {
           console.log('XXXXX CARICAMENTO RIUSCITO')

           props.funzione_scelta_video({indice: 0, url: data.data[0].file})
           console.log(utente_new)

           set_in_lista_youtube_caricata(true)
        }
      }
      ).catch(err => {
          console.log('errore in axios youtube')
          console.log(err)
          return null
    })
};


const submitValue = () => {

//    props.funzione_set_lista_utenti({ nome: nome, cognome: cognome, creato: true, indice_video: -1, 
//        video_guardati: [file:], })
    console.log ('video 0')
//    chiamata_file_php_caricamento_utente_todo ()
    chiamata_file_php_lista_youtube ()
}

  return (
  <div>
  <div>
      
      <input type="text" placeholder="Nome" onChange={e => set_nome(e.target.value)} />
      </div>
      <div>
 
      <input type="text" placeholder="Cognome" onChange={e => set_cognome(e.target.value)} />
      </div>
      <div>
 
      <button data-tip data-for="registerTip" onClick={submitValue}>Carica Video</button>
      </div>
      
  </div>
  )
}

export default Caricamento_dati_utente;